var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('router-link',{attrs:{"to":{ name: 'Logout' }}},[_c('img',{attrs:{"src":"/img/dashboard/logout_icon_menu.svg","alt":"icon"}}),_vm._v("Log out")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }